import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import Button from '@/Components/Button/Button';
import SubscriptionStatusText from './SubscriptionStatusText';
import { useApplication } from '@/Components/ApplicationProvider';
import { c } from 'ttag';
const SubscriptionInformation = () => {
    const application = useApplication();
    const isSharedSubscription = application.subscriptionController.isSharedSubscription;
    const manageSubscription = async () => {
        void application.openSubscriptionDashboard.execute();
    };
    return (_jsxs(_Fragment, { children: [_jsx(SubscriptionStatusText, {}), !isSharedSubscription && application.canShowPurchaseFlow() && (_jsx(Button, { className: "mr-3 mt-3 min-w-20", label: c('B6.Preferences.Subscription.Label').t `Manage subscription`, onClick: manageSubscription }))] }));
};
export default observer(SubscriptionInformation);
